const MODE = process.env.VUE_APP_MODE // "DEV" or "PROD"

const config = {
	MODE: MODE,
	SERVER_BASE_URL: MODE === "DEV" ? "http://localhost:3000" : "https://api.podplayer.co"
}

export default config